import { SortType, handleSort } from '../../../constants/tool-order';

/** 额外费用销售分析表列 id → 排序类型。 */
export const EXTRA_ANALYSIS_SORT_COLUMN_TYPES: Record<string, 'Date' | 'Number' | 'String'> = {
    name: 'String',
    sum_quantity: 'Number',
    sum_price: 'Number',
    count_percentage: 'Number',
};

/** 菜单菜品销售分析表列 id → 排序类型。 */
export const DISH_SALES_SORT_COLUMN_TYPES: Record<string, 'Date' | 'Number' | 'String'> = {
    menu_name: 'String',
    category_name: 'String',
    item_name1: 'String',
    item_name2: 'String',
    total_quantity: 'Number',
    total_amount: 'Number',
    return_rate: 'Number',
    sales_ratio: 'Number',
};

/** 菜品出菜效率分析表列 id → 排序类型。 */
export const EFFICIENCY_ANALYSIS_SORT_COLUMN_TYPES: Record<string, 'Date' | 'Number' | 'String'> = {
    menu_item_name: 'String',
    item_name2: 'String',
    quantity: 'Number',
    average_time: 'Number',
};

/**
 * 对当前页表格行做前端排序；无有效排序态时返回原数组引用。
 * @param rows - 待排序行（通常为筛选后列表）
 * @param sort - 当前排序 key 与 ASC/DESC
 * @param columnTypes - 列 id 与排序类型映射
 * @returns 排序后的新数组
 */
export function applyClientTableSort<T>(
    rows: T[],
    sort: SortType,
    columnTypes: Record<string, 'Date' | 'Number' | 'String'>,
): T[] {
    if (!sort.key || !sort.value) {
        return rows;
    }
    /** 列对应的比较类型，未知列按字符串处理。 */
    const sortType = columnTypes[sort.key] ?? 'String';
    return (handleSort(sort, [...rows], sortType) as T[]) ?? rows;
}
